import { Reducer } from 'redux';
import { SET_ROUTES } from '../actions';

const usersInitialState: IRouterState = {
  routes: [],
};

const usersReducer: Reducer = (
  state = usersInitialState,
  { type, payload },
) => {
  switch (type) {
    case SET_ROUTES:
      return { ...state, routes: payload };
    default:
      return state;
  }
};

export default usersReducer;

export interface IRouterState {
  routes: string[];
}



// WEBPACK FOOTER //
// ./src/store/reducers/routerReducer.ts